import React from 'react';

import ContentItemNew from 'common/charts/types/ContentItem/ContentItemNew';
import { isDisplayFormatEnabled } from 'common/helpers/featureFlags';
import SyncedInfo from 'common/components/Autosync/SyncedInfo';
import { ResponseFormatTypeChange } from 'common/components/FormatTypeInfo/FormatTypeInfo';
import { MiniLoader } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import {
  getIsThirdPartyMember,
  getUserRole,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { USER_ROLES } from '@pwc/pwc-deals-web-common';

interface LibraryItemShort {
  content: string;
  type: string;
  formatType: string;
  id: number;
  isDisplayedFormatType: boolean;
}

interface PanelProp {
  contentsWithFormatType: Array<LibraryItemShort>;
  statusType: number;
  error?: { apiErrorCode: string };
}

interface TopicLibraryItemCardProps {
  projectId: string;
  content: string;
  panel: PanelProp;
  excelPPTItem: { libraryItemId: number };
  onFormatTypeChange: (
    panel: PanelProp,
    libraryItemId: string,
    formatType: string,
    needMergePanels: boolean
  ) => void;
}

const TopicLibraryItemCard: React.FC<TopicLibraryItemCardProps> = ({
  projectId,
  content,
  panel,
  excelPPTItem,
  onFormatTypeChange,
}) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  const { contentsWithFormatType, error } = panel;
  const cellRangeContent =
    [302, 301].includes(panel.statusType) && isDisplayFormatEnabled
      ? contentsWithFormatType.find((x) => x.isDisplayedFormatType)
      : undefined;

  const contentToDisplay = cellRangeContent?.content || content;

  const handleClickFormatType = (
    response: ResponseFormatTypeChange,
    libraryItemId: string
  ) => {
    if (response) {
      onFormatTypeChange(panel, libraryItemId, response.data?.formatType, true);
    }
  };

  if (!contentToDisplay && !error) {
    return <MiniLoader dataTestId="excel-content-loader" />;
  }

  return (
    <>
      <ContentItemNew
        content={contentToDisplay}
        projectId={projectId}
        libraryItem={excelPPTItem}
        libraryItemId={undefined}
        contentId={undefined}
        panel={panel}
      />
      {excelPPTItem && contentToDisplay && !isThirdPartyMember && (
        <SyncedInfo
          projectId={projectId}
          excelPPTItem={excelPPTItem as never}
          handleClickFormatType={handleClickFormatType}
          isPwcUser={isPwcUser}
        />
      )}
    </>
  );
};

export default TopicLibraryItemCard;
